import { render, staticRenderFns } from "./teachingResearchHomePage.vue?vue&type=template&id=17758a14&scoped=true"
import script from "./teachingResearchHomePage.vue?vue&type=script&lang=js"
export * from "./teachingResearchHomePage.vue?vue&type=script&lang=js"
import style0 from "./teachingResearchHomePage.vue?vue&type=style&index=0&id=17758a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17758a14",
  null
  
)

export default component.exports